import request from '@/utils/request'

const api_prefix = '/system'

// 获取系统配置
export function getSystemConfig() {
    return request({
        url: api_prefix + '/getconfigs',
        method: 'get',
    })
}

// 获取会员须知
export function getMemberAgreement() {
    return request({
        url: api_prefix + '/getMemberAgreement',
        method: 'get',
    })
}

// 获取课程发布提示
export function getCoursePublishTip() {
    return request({
        url: api_prefix + '/getCoursePublishTip',
        method: 'get',
    })
}